type LinkObject = {
  id: string;
  url: string;
  target?: string;
  linktype: 'url' | 'asset' | 'email' | 'story';
  fieldtype: string;
  cached_url: string;
  email?: string;
  anchor?: string;
};

function parseUrlLink(link: LinkObject): string {
  const anchor = link.anchor
    ? link.anchor
    : link.url.includes('#')
    ? link.url.substring(link.url.indexOf('#'))
    : '';
  const baseUrl = link.url.includes('#')
    ? link.url.substring(0, link.url.indexOf('#'))
    : link.url;

  if (baseUrl === 'home' || baseUrl === '/de/home') {
    return '/' + anchor;
  }

  return link.url;
}

function parseAssetLink(link: LinkObject): string {
  return link.url;
}

function parseEmailLink(link: LinkObject): string {
  return `mailto:${link.email || link.url}`;
}

function parseStoryLink(link: LinkObject): string {
  if (link.cached_url === 'home' || link.cached_url === '/de/home') {
    return '/';
  }

  return link.cached_url;
}

function parseStoryblokLink(link: LinkObject): string {
  switch (link?.linktype) {
    case 'url':
      return parseUrlLink(link);
    case 'asset':
      return parseAssetLink(link);
    case 'email':
      return parseEmailLink(link);
    case 'story':
      return parseStoryLink(link);
    default:
      return '';
  }
}

export default parseStoryblokLink;
